import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable, of, Subject} from 'rxjs';
import {SharedService} from '../shared/shared.service';
import {HttpClient} from '@angular/common/http';
import {catchError, mergeMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OrderGuard implements CanActivate {
  subject: Subject<any> = new Subject<any>();

  constructor(
    public sharedService: SharedService,
    public router: Router,
    private http: HttpClient) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.sharedService.loadingStep = {title: 'loading.almostDone', subTitle: 'loading.paymentProcessing'};
    this.http.post(`/api/v1/order/`, {
      'email': 'asdasd@asd.asd',
      'payment': {
        'natId': '123456789',
        'sumaLV': '450.50'
      }
    }).pipe(catchError(error => {
      this.sharedService.loadingStep = false;
      return of(false);
    }), mergeMap(something => {
      this.sharedService.loadingStep = false;
      if (something) {
        route.data = {...route.data, dto: something};
        return of(true);
      } else {
        return of(this.router.createUrlTree(['unsuccessfulPayment']));
        // return of(false);
      }
    })).subscribe(res => {
      this.subject.next(res);
    });
    return this.subject;
  }

}
